import React from "react";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import FileInputLocal, {READ_AS_FILE} from "../file-input-local";
import EasyLoadingForm, {MAX_TITLE_LENGTH} from "../package-manager/EasyLoadingForm";

const EtlWizardStepFile = ({dataset, setDataset, resource, setResource, errorMessage, disabled, ...props}) => {
  const {t} = useTranslation();

  return (
    <Box className="etl-wizard__step-file" sx={{marginTop: errorMessage ? "16px" : "24px"}}>
      <EasyLoadingForm
        {...props}
        dataset={dataset}
        setDataset={setDataset}
        resource={resource}
        setResource={setResource}
        disabled={disabled || !resource?.content}
        sourceField={
          <FileInputLocal
            className="etl-wizard__dataset__file-field"
            label={t("modules.packageManager.etlWizard.dataset.fields.file.label")}
            variant="outlined"
            accept=".csv,.zip,.gz,.gzip,.7z"
            readAs={READ_AS_FILE}
            value={resource?.fileName}
            onChange={(file, fileName, fileExtension) => {
              setDataset({
                ...dataset,
                title: fileName ? fileName.slice(0, MAX_TITLE_LENGTH) : null,
                description: fileName
              });
              setResource({
                ...resource,
                title: fileName ? fileName.slice(0, MAX_TITLE_LENGTH) : null,
                content: file,
                fileName: file ? `${fileName}.${fileExtension}` : null,
                format: fileExtension
              });
            }}
            error={false}
            required
            fullWidth
            disabled={disabled}
          />
        }
      />
    </Box>
  );
};

export default EtlWizardStepFile;
